import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import createCache from './createCache.esm.js';
import fetchFeatureFlags from './fetchFeatureFlags.esm.js';
import fetchFeatureFlagOverrides from './fetchFeatureFlagOverrides.esm.js';

var initialCache = /*#__PURE__*/createCache();

var mergeResultsAndOverrides = function mergeResultsAndOverrides(_ref) {
  var fetchedResults = _ref.fetchedResults,
      featureFlagOverrides = _ref.featureFlagOverrides,
      featureFlags = _ref.featureFlags;
  var overriddenValues = Object.keys(featureFlagOverrides).filter(function (overriddenFeatureFlag) {
    return featureFlags.includes(overriddenFeatureFlag);
  }).reduce(function (obj, key) {
    obj[key] = featureFlagOverrides[key];
    return obj;
  }, {});
  return _extends({}, fetchedResults, overriddenValues);
};

var createFeatureFlagsClient = function createFeatureFlagsClient(_temp) {
  var _ref2 = _temp === void 0 ? {} : _temp,
      host = _ref2.host,
      environment = _ref2.environment,
      featureFlagOverrideUrl = _ref2.featureFlagOverrideUrl;

  var overridePromise = fetchFeatureFlagOverrides({
    environment: environment,
    featureFlagOverrideUrl: featureFlagOverrideUrl
  });
  return {
    get: function get(_ref3, cache) {
      var featureFlags = _ref3.featureFlags,
          _ref3$trackingId = _ref3.trackingId,
          trackingId = _ref3$trackingId === void 0 ? '' : _ref3$trackingId,
          allowlistValues = _ref3.allowlistValues;

      if (cache === void 0) {
        cache = initialCache;
      }

      return overridePromise.then(function (featureFlagOverrides) {
        cache.set(featureFlagOverrides);
        var allCachedFlags = cache.get(featureFlags);

        if (allCachedFlags) {
          return Promise.resolve(allCachedFlags);
        }

        return fetchFeatureFlags({
          featureFlags: featureFlags,
          host: host,
          trackingId: trackingId,
          allowlistValues: allowlistValues
        }).then(function (fetchedResults) {
          return mergeResultsAndOverrides({
            fetchedResults: fetchedResults,
            featureFlagOverrides: featureFlagOverrides,
            featureFlags: featureFlags
          });
        });
      }).then(function (requestedFeatureFlags) {
        cache.set(requestedFeatureFlags);
        return requestedFeatureFlags;
      });
    }
  };
};

export default createFeatureFlagsClient;
//# sourceMappingURL=createFeatureFlagsClient.esm.js.map
